// export default [
//   { name: "🐶 Sweet Dogos", id: "sweet-dogos" },
//   { name: "🧐 Serious Meetups", id: "serious-meetups" },
//   { name: "😎 Cool People", id: "cool-people" },
//   { name: "💸 Just Degens", id: "just-degens" },
//   { name: "🇵🇱 Polish DAO", id: "polish-dao" },
//   { name: "🧜‍♀️ EthWarsaw", id: "eth-warsaw" },
//   { name: "👩🏻‍💻 Blockchain Devs", id: "blockchain-devs" },
// ];

export default {
  "sweet-dogos": "🐶 Sweet Dogos",
  "serious-meetups": "🧐 Serious Meetups",
  "cool-people": "😎 Cool People",
  "just-degens": "💸 Just Degens",
  "polish-dao": "🇵🇱 Polish DAO",
  "eth-warsaw": "🧜‍♀️ EthWarsaw",
  "blockchain-devs": "👩🏻‍💻 Blockchain Devs",
};
